import React from 'utils/react';

import { Redirect } from 'react-router';

export default ({ defaultPage }) => <Redirect to={defaultPage} />;
